/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  getAddressEncoder,
  getProgramDerivedAddress,
  getUtf8Encoder,
  type Address,
  type ProgramDerivedAddress,
} from "@solana/kit";

export type PositionNftAccountSeeds = {
  /** The position NFT mint address */
  positionNftMint: Address;
};

/**
 * The token account that holds the position NFT.
 * This is a program-owned account that stores the NFT representing a liquidity position.
 */
export async function findPositionNftAccountPda(
  seeds: PositionNftAccountSeeds,
  config: { programAddress?: Address | undefined } = {},
): Promise<ProgramDerivedAddress> {
  const {
    programAddress = "cpamdpZCGKUy5JxQXB4dcpGPiikHawvSWAd6mEn1sGG" as Address<"cpamdpZCGKUy5JxQXB4dcpGPiikHawvSWAd6mEn1sGG">,
  } = config;
  return await getProgramDerivedAddress({
    programAddress,
    seeds: [
      getUtf8Encoder().encode("position_nft_account"),
      getAddressEncoder().encode(seeds.positionNftMint),
    ],
  });
}
